export class GetMedicineRequest {
     public listIdMedicine: number[] = [];
}